import BaseTracker from './BaseTracker';

export type FacebookUserData = {
  email: string;
  lastName: string;
  firstName: string;
  phoneNumber: string;
};

export type FacebookUserDataSource = () => FacebookUserData;

/**
 * Sends events to Facebook Pixel and Google analytics
 * based on a custom Google Tag Management Whitelist named fbGaTrackerEventWhitelist.
 */
class FacebookTracker extends BaseTracker {
  getFacebookUserData: FacebookUserDataSource;

  constructor(env: string, platform: string, getFacebookUserData: FacebookUserDataSource) {
    super('Facebook', 'Tracker (FB)', env, platform);
    this.getFacebookUserData = getFacebookUserData;
  }

  private createFacebookParams = existingProps => {
    const paramsForFb: Object = {};
    const fbPropsListMap = {
      event_time_iso_8601: 'timestamp',
      platform: 'platform',
      user_agent: 'client_user_agent',
      firstName: 'fn',
      lastName: 'ln',
      email: 'em',
      phoneNumber: 'ph',
      fbc: 'fbc',
    };
    Object.keys(fbPropsListMap).forEach(key => {
      const fbParam = fbPropsListMap[key];
      if (key === 'phoneNumber' && existingProps[key]) {
        paramsForFb[fbParam] = existingProps[key];
      } else {
        paramsForFb[fbParam] = existingProps[key] || null;
      }
    });
    return paramsForFb;
  };

  /**
   * Performs the actual tracking call.
   * @param {String} eventName The name of the event to track
   * @param {Object} properties The properties to track
   * @returns {Promise} Resolves when the event has been logged.
   */
  trackEvent(eventName, properties) {
    // check if the app is running under web platform;
    // condition check to make sure there is a window object;
    // If 'web', sign array from fbGaTrackerEventWhitelist in GTM to gtmWhitelist;
    if (this.platform !== 'web') {
      return;
    }
    // @ts-ignore
    const gtmWhitelist = window.fbGaTrackerEventWhitelist || [];
    const trackEventName = eventName;
    // if the event to track is in the Google Tag Management whitelist array
    if (gtmWhitelist.includes(trackEventName)) {
      // check if the facebook piexl base code is running
      // @ts-ignore
      if (typeof window.fbq === 'function') {
        const fbParams = this.createFacebookParams({
          ...properties,
          ...this.getFacebookUserData(),
        });
        // send event to Facebook Pixel; only pass the properties that facebook needs
        // @ts-ignore
        window.fbq('trackCustom', trackEventName, fbParams, { eventID: properties.event_id });
        this.debugLog('trackEvent', trackEventName, fbParams);
      }
    }
  }
}

export default FacebookTracker;
